import { UrlConstants } from "../url.constants";
export class ApiEhPremiseTypeSurveyConstants {
    static URL = UrlConstants.API_V2 + "EhPremiseTypeSurvey";
    static FUNCTION_DELETE = "Delete";
    static FUNCTION_PATCH = "Patch";
    static FUNCTION_GET = "GET";
}
